/* highlighter.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import React from "react";
import theme from "../theme";
var _10 = "._key71u6e .prosemirror-dev-tools-highlighter-tag{color:#cba6f7}";
var _9 = "._syazryvq{color:rgba(205,214,244,.8)}";
var _8 = "._18u0idpf{margin-left:0}";
var _7 = "._otyridpf{margin-bottom:0}";
var _6 = "._2hwxidpf{margin-right:0}";
var _5 = "._19pkidpf{margin-top:0}";
var _4 = "._19bvgrf3{padding-left:0!important}";
var _3 = "._n3td1o4j{padding-bottom:18px!important}";
var _2 = "._u5f3grf3{padding-right:0!important}";
var _ = "._ca0q1vy9{padding-top:9px!important}";
var customPreStyles = null;
var CustomPre = function CustomPre(_ref) {
  var children = _ref.children,
    __html = _ref.__html;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10]), /*#__PURE__*/React.createElement("pre", {
    dangerouslySetInnerHTML: {
      __html: __html
    },
    className: ax(["_ca0q1vy9 _u5f3grf3 _n3td1o4j _19bvgrf3 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazryvq _key71u6e"])
  }, children));
};
var regexp = /(&lt;\/?[\w\d\s="']+&gt;)/gim;
var highlight = function highlight(str) {
  return str.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(regexp, "<span class='prosemirror-dev-tools-highlighter-tag'>$&</span>");
};
export var Highlighter = function Highlighter(props) {
  if (!props.children) return null;
  return /*#__PURE__*/React.createElement(CustomPre, {
    __html: highlight(props.children)
  });
};